/**
 * Scanned Results 페이지의 행 모델.
 *
 * 정렬 키가 되는 값만 public 으로 노출한다 — c6 `DataTable` 의 컬럼 key 는 행의 public 필드에서
 * 고르고 기본 `compare` 가 그 값을 그대로 비교한다. 본 시각은 ms 정수로 들어 문자열 정렬로
 * 새지 않는다.
 *
 * 행 클릭은 없다. 후보는 아직 열어 볼 상세가 없고, 할 일은 수락 · 폐기 둘뿐이다.
 *
 * Owns:
 * - 행 식별과 정렬 값, 행 액션 배선.
 *
 * Does not own:
 * - 조회 — `CandidateTableSource.ts`. 셀 표현 — `candidateColumns.tsx`.
 */
import type { ReactNode } from "react";
import { TableRow } from "@carbon6/c6-frontend-design";
import type { Candidate } from "../domain/candidate";
import type { DatasetFormat } from "../domain/dataset";

export type CandidateRowOptions = {
  /** 행 우측 액션. 행마다 자기 후보를 닫아 넘긴다. */
  renderActions?: (candidate: Candidate) => ReactNode;
};

export class CandidateTableRow extends TableRow {
  readonly uuid: string;
  readonly sourceRef: string;
  readonly rootCode: string;
  readonly format: DatasetFormat;
  readonly formatVersion: string | null;
  readonly formatDetail: string | null;
  readonly canProbe: boolean;
  readonly firstSeenAtMs: number;
  readonly lastSeenAtMs: number;

  constructor(candidate: Candidate, { renderActions }: CandidateRowOptions) {
    super(renderActions === undefined ? null : () => renderActions(candidate));
    this.uuid = candidate.uuid;
    this.sourceRef = candidate.sourceRef;
    this.rootCode = candidate.rootCode;
    this.format = candidate.format;
    this.formatVersion = candidate.formatVersion;
    this.formatDetail = candidate.formatDetail;
    this.canProbe = candidate.canProbe;
    this.firstSeenAtMs = candidate.firstSeenAtMs;
    this.lastSeenAtMs = candidate.lastSeenAtMs;
  }

  override getRowId(): string {
    return this.uuid;
  }

  override canShow(): boolean {
    return true;
  }

  /** 일괄 액션이 없다 — 수락 · 폐기는 한 건씩 판단한다. */
  override canSelect(): boolean {
    return false;
  }

  override get isRowClickable(): boolean {
    return false;
  }
}
